module.exports = __webpack_public_path__ + "img/047-magician.47234519.png";